import { Icon, Icons } from '@silverfort/sf-components';
import { FC } from 'react';
import { WizardStep, WizardStepsSx } from './types';

export interface WizardStepsProps {
    steps: WizardStep[];
    className?: string;
    sx?: WizardStepsSx;
}

const getStepIcon = (step: WizardStep) => {
    if (step.isActive) return Icons.ArrowForward;
    if (step.isCompleted) return Icons.Check;
    if (step.isSkipped) return Icons.Circle;
    return Icons.Remove;
};

const WizardSteps: FC<WizardStepsProps> = ({ steps, className, sx }) => {
    return (
        <div className={`h-full w-2/12 py-6 flex font-sf flex-col gap-4 ${className}`} style={sx?.root}>
            {steps.map((step, index) => (
                <div
                    key={index}
                    id={step.id}
                    className={`h-6 flex items-center gap-2 flex-wrap ${step.onClick ? 'cursor-pointer' : ''}
                    ${step.isActive ? 'text-sf-primary-500' : ''} ${step.isCompleted ? 'text-sf-gray-700' : ''}
                    ${!step.isActive && !step.isCompleted ? 'text-sf-gray-400' : ''} ${className ?? ''}`}
                    onClick={step.onClick}
                    style={sx?.step}>
                    <div className="flex gap-1 items-center w-full">
                        <Icon icon={getStepIcon(step)} className="h-6 w-6" style={sx?.icon} />
                        <span className={'text-14 font-medium truncate'} style={sx?.title}>
                            {step.title}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default WizardSteps;
